import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    feedback: "",
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get the current user info
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert("Please log in to submit feedback.");
      return;
    }

    setLoading(true);
    try {
      // Add feedback to Firestore
      await addDoc(collection(db, "feedback"), {
        userID: user.uid,
        name: formData.name || user.displayName || "Anonymous",
        email: formData.email || user.email,
        feedback: formData.feedback,
        time: Timestamp.now(),
      });

      alert("Thank you for your feedback!");
      setFormData({ name: "", email: "", feedback: "" });
    } catch (error) {
      console.error("Error submitting feedback: ", error);
      alert("Failed to submit feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "50px auto", // Add margin to center and space from the navbar
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        fontFamily: "'Roboto', sans-serif",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "#007bff",
        }}
      >
        Feedback & Support
      </h1>
      <p style={{ marginBottom: "20px", color: "#333", textAlign: "center" }}>
        Tell us what you think! Need improvements? Want something you don't see?
        Let us know below.
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <label
            htmlFor="name"
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "5px",
              color: "#000", // Black color for "Your Name"
            }}
          >
            Your Name:
          </label>
          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter your name"
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            required
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label
            htmlFor="email"
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "5px",
              color: "#000", // Black color for "Your Email"
            }}
          >
            Your Email:
          </label>
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter your email"
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            required
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label
            htmlFor="feedback"
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "5px",
              color: "#000", // Black color for "Feedback"
            }}
          >
            Feedback:
          </label>
          <textarea
            id="feedback"
            name="feedback"
            value={formData.feedback}
            onChange={handleInputChange}
            placeholder="Enter your feedback here"
            rows="5"
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            required
          ></textarea>
        </div>
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
          }}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Feedback"}
        </button>
      </form>
      <div
        style={{
          marginTop: "20px",
          textAlign: "center",
          color: "black",
          fontSize: "1em",
        }}
      >
        <p>
          Interested in investing? <br/> Email us at{" "}
          <a href="mailto:jordandye475@gmail.com" style={{ color: "#007bff" }}>
            jordandye475@gmail.com
          </a>{" "}
          or call/text us directly at{" "}
          <strong style={{ color: "#007bff" }}>469-834-9406</strong>.
        </p>
      </div>
    </div>
  );
};

export default Feedback;
